import SaveIcon from '@mui/icons-material/Save';
import {
    usePortfolioSelection,
    useOrders,
} from "../../../shared/contexts/portfolio-context/components/PortfolioContextProvider";
import { ToolsPanelButton } from "./ToolsPanelButton";
import { customImpliedVolatilityInfoBuilder } from "../utils/CustomImpliedVolatilityInfoBuilder";

export function SaveCustomImpliedVolatilityButton(){
    const {
        selectedPortfolio,
        isAllPortfoliosSelected,
    } = usePortfolioSelection();
    const {
        saveCustomImpliedVolatility,
    } = useOrders();
    
    const handleSavePortfolio = async (): Promise<void> => {
        if (!selectedPortfolio || isAllPortfoliosSelected) {
            return;
        }

        const { positionsForUpdate, ordersForUpdate } =
            customImpliedVolatilityInfoBuilder.build(selectedPortfolio);
        
        await saveCustomImpliedVolatility(positionsForUpdate, ordersForUpdate);
    };
    
    return (
        <ToolsPanelButton
            tooltipText="Save custom implied volatility values for positions and related orders"
            disabled={isAllPortfoliosSelected}
            onChanged={handleSavePortfolio}
        >
            <SaveIcon sx={{
                height: '18px',
                width: '18px',
            }} />
        </ToolsPanelButton>
    );
}
